import React, { useRef } from 'react';
import useClickOutside from '../../../hooks/useClickOutside';
import styles from './WorkshopModal.module.css';

const WorkshopModal = ({ isOpen, onClose, onSubmit, formValues, handleInputChange, isEditMode, formError }) => {
  const modalRef = useRef(null);

  useClickOutside(modalRef, onClose, isOpen);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.content} ref={modalRef}>
        <button className={styles.close} onClick={onClose}>X</button>
        <form onSubmit={onSubmit} className={styles.form}>
          <h2 className={styles.formTitle}>{isEditMode ? 'Editar Taller' : 'Crear Taller'}</h2>
          {formError && <p className={styles.formError}>{formError}</p>}
          <div className={styles.formGroup}>
            <input
              type="text"
              name="nombre"
              className={styles.formInput}
              placeholder="Nombre"
              maxLength={100}
              value={formValues.nombre}
              onChange={handleInputChange}
            />
          </div>
          <div className={styles.formGroup}>
            <input
              type="text"
              name="descripcion"
              className={styles.formInput}
              placeholder="Descripción"
              value={formValues.descripcion}
              onChange={handleInputChange}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              Fecha de Inicio:
              <input
                type="date"
                name="fechaInicio"
                className={styles.formInput}
                value={formValues.fechaInicio}
                onChange={handleInputChange}
              />
            </label>
          </div>
          <div className={styles.submitContainer}>
            <button type="submit" className={styles.submit}>
              {isEditMode ? 'Editar Taller' : 'Crear Taller'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WorkshopModal;
